/** CSS contract: css-library/components/01-leaves/status-line.css. */
import type { Ref } from 'react';
import type { ElementType, HTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';

export type StatusLineTone = 'success' | 'error';

export interface StatusLineProps extends HTMLAttributes<HTMLElement> {
  tone?: StatusLineTone;
  strong?: boolean;
  icon?: ReactNode;
  as?: 'p' | 'span' | 'div';
}

export function StatusLine(
  { ref, tone, strong = false, icon, as = 'p', className, children, ...rest }: StatusLineProps & { ref?: Ref<HTMLElement> },
) {
  const Tag = as as ElementType;
  return (
    <Tag
      ref={ref}
      className={cx('status-line', tone && `is-${tone}`, strong && 'status-line--strong', className)}
      {...rest}
    >
      {icon}
      {children}
    </Tag>
  );
}
